<template>
  <v-app>
    <v-navigation-drawer
      class="v-navigation-drawer-cart"
      :value="cartOnRightShown()"
      right
      width="300"
      fixed
      touchless
      :permanent="cartOnRightShown()"
    >
      <v-container v-if="$store.state.order != null">
        <Cart :currentRouteName="$router.currentRoute.name" :key="$store.state.cartKey"></Cart>
      </v-container>
    </v-navigation-drawer>

    <v-main
      :class="[
        $vuetify.breakpoint.mdAndUp
          ? $router.currentRoute.name == 'MenuFull' ||
            $router.currentRoute.name == 'MenuCategory' ||
            ($router.currentRoute.name == 'MenuItem' && $router.currentRoute.params.getNewBundleItem == null)
            ? 'desktop-mode-padding-right'
            : ''
          : '',
        'mb-14',
      ]"
    >
      <keep-alive>
        <router-view :key="routeViewKey" />
      </keep-alive>
    </v-main>

    <v-bottom-navigation
      fixed
      v-model="$store.state.appTabBarIndex"
      color="accent"
      v-show="$route.meta && $route.meta.tabBar"
    >
      <v-btn @click="navName('Home')" :class="$store.state.appTabBarIndex == 0 ? 'nav-btn-highlight' : ''">
        <span>{{ $t("home") }}</span>

        <v-icon>mdi-home-outline</v-icon>
      </v-btn>

      <v-btn @click="navOrder" :class="$store.state.appTabBarIndex == 1 ? 'nav-btn-highlight' : ''">
        <span>{{ $t("order") }}</span>

        <v-icon>mdi-cart-outline</v-icon>
      </v-btn>

      <v-btn @click="offerClicked" :class="$store.state.appTabBarIndex == 2 ? 'nav-btn-highlight' : ''">
        <span>{{ $t("offer") }}</span>

        <v-icon>mdi-ticket-percent-outline</v-icon>
      </v-btn>

      <v-btn @click="navName('More')" :class="$store.state.appTabBarIndex == 3 ? 'nav-btn-highlight' : ''">
        <span>{{ $t("more") }}</span>

        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <MessageDialog ref="messageDialog"></MessageDialog>
    <BarcodeDialog ref="barcodeDialog"></BarcodeDialog>
    <ConfirmDialog ref="confirmDialog"></ConfirmDialog>
    <CustomFormDialog ref="customFormDialog"></CustomFormDialog>
    <AddressListDialog class="address-list-dialog" ref="addressListDialog"></AddressListDialog>
    <LocationDialog ref="locationDialog"></LocationDialog>
    <MemberGiftcardDialog ref="memberGiftcardDialog"></MemberGiftcardDialog>
    <MemberGiftcardTransDialog ref="memberGiftcardTransDialog"></MemberGiftcardTransDialog>
    <MemberLoginDialog ref="memberLoginDialog"></MemberLoginDialog>
    <MemberPointDialog ref="memberPointDialog"></MemberPointDialog>
    <MemberProfileDialog ref="memberProfileDialog"></MemberProfileDialog>
    <OrderHistoryDialog ref="orderHistoryDialog"></OrderHistoryDialog>
    <PhoneVerificationDialog ref="phoneVerificationDialog"></PhoneVerificationDialog>
    <PrivacyDialog ref="privacyDialog"></PrivacyDialog>
    <StoreListDialog ref="storeListDialog"></StoreListDialog>
    <TableNameDialog ref="tableNameDialog"></TableNameDialog>
  </v-app>
</template>

<script>
import Vue from "vue";
import Dexie from "dexie";

import { Plugins } from "@capacitor/core";

import { mixins } from "./mixins";

import MessageDialog from "@/dialogs/MessageDialog";
import BarcodeDialog from "@/dialogs/BarcodeDialog";
import ConfirmDialog from "@/dialogs/ConfirmDialog";
import CustomFormDialog from "@/dialogs/CustomFormDialog";

import AddressListDialog from "@/dialogs/AddressListDialog";
import LocationDialog from "@/dialogs/LocationDialog";
import MemberGiftcardDialog from "@/dialogs/MemberGiftcardDialog";
import MemberGiftcardTransDialog from "@/dialogs/MemberGiftcardTransDialog";
import MemberLoginDialog from "@/dialogs/MemberLoginDialog";
import MemberPointDialog from "@/dialogs/MemberPointDialog";
import MemberProfileDialog from "@/dialogs/MemberProfileDialog";
import OrderHistoryDialog from "@/dialogs/OrderHistoryDialog";
import PhoneVerificationDialog from "@/dialogs/PhoneVerificationDialog";
import PrivacyDialog from "@/dialogs/PrivacyDialog";
import StoreListDialog from "@/dialogs/StoreListDialog";
import TableNameDialog from "@/dialogs/TableNameDialog";

import Cart from "@/components/Cart.vue";
import swUpdates from "@/mixins/swUpdates";

export default {
  name: "App",
  mixins: [mixins, swUpdates],

  components: {
    MessageDialog,
    BarcodeDialog,
    ConfirmDialog,
    CustomFormDialog,
    AddressListDialog,
    LocationDialog,
    MemberGiftcardDialog,
    MemberGiftcardTransDialog,
    MemberLoginDialog,
    MemberPointDialog,
    MemberProfileDialog,
    OrderHistoryDialog,
    PhoneVerificationDialog,
    PrivacyDialog,
    StoreListDialog,
    TableNameDialog,

    Cart,
  },

  data: () => ({
    refreshing: false,
  }),

  async created() {
    this.refreshing = true;

    console.log("app created");
    console.log("userAgent", navigator.userAgent);

    const { Device } = Plugins;
    this.$store.state.deviceInfo = await Device.getInfo();
    console.log("deviceInfo", this.$store.state.deviceInfo);

    let idbName = "do-db";
    if (this.$mrsConfig.idbName != null) {
      idbName = this.$mrsConfig.idbName;
    }
    if (this.$devEnv && this.$mrsConfig.dev != null) {
      if (this.$mrsConfig.dev.idbName != null) {
        idbName = this.$mrsConfig.dev.idbName;
      }
    }

    let idb = new Dexie(idbName);
    idb.version(0.1).stores({
      setting: "name",
    });
    Vue.prototype.$idb = idb;

    let urlSearch = new URLSearchParams(window.location.search);
    let queryKey = urlSearch.get("key");
    let urlHost = window.location.host;
    let urlOrigin = window.location.origin;
    let urlPathname = window.location.pathname;

    if (urlPathname != "/") {
      urlPathname = urlPathname.substring(1);
      let paths = urlPathname.split("/");
      if (paths.length >= 2) {
        let startIndex = 0;
        this.$store.state.appToken = {
          CompanyCode: unescape(paths[startIndex]),
          DataId: paths[startIndex + 1],
        };
      }
    }

    console.log("BASE_URL", process.env.BASE_URL);
    console.log("queryKey", queryKey);
    console.log("urlHost", urlHost);
    console.log("urlOrigin", urlOrigin);
    console.log("urlPathname", urlPathname);

    this.getMyCoords().then(myCoords => {
      this.$store.state.myCoords = myCoords;
    });

    if (this.$store.state.appToken == null || this.isEmptyObject(this.$store.state.appToken)) {
      if (this.$mrsConfig.token != null) this.$store.state.appToken = this.$mrsConfig.token;
    }
    if (this.$devEnv && this.$mrsConfig.dev != null) {
      if (this.$mrsConfig.dev.token != null) {
        this.$store.state.appToken = this.$mrsConfig.dev.token;
      }
    }
    console.log("appToken", this.$store.state.appToken);

    this.$store.state.rootName = "Stores";

    if (this.$mrsConfig.appLogoSrc != null) this.$store.state.appLogoSrc = this.$mrsConfig.appLogoSrc;
    if (this.$mrsConfig.membershipCardLogoSrc != null)
      this.$store.state.membershipCardLogoSrc = this.$mrsConfig.membershipCardLogoSrc;

    if (this.$mrsConfig.termsOfUseUrl != null) {
      let termsOfUseUrl = this.$mrsConfig.termsOfUseUrl;
      if (termsOfUseUrl != "") {
        fetch(termsOfUseUrl)
          .then(response => {
            response.text().then(result => {
              this.$store.state.termsOfUseContent = result;
            });
          })
          .catch(error => {
            console.log(error);
          });
      }
    }

    if (this.$mrsConfig.languages != null) this.$store.state.languages = this.$mrsConfig.languages;
    if (this.$store.state.languages.length > 0) {
      let langId = this.getLanguageIdFromStorage();
      let lang;
      if (langId > 0) lang = this.$store.state.languages.find(lang => lang.id == langId);
      if (lang == null) lang = this.$store.state.languages[0];
      this.setLanguage(lang);
    }

    this.loadAddressList();

    if (this.$devEnv) {
      this.$store.state.apiUrl = "http://x.mrsdigi.com/do/server/webroot/";
    }

    this.$store.state.doApiUrl = this.$store.state.apiUrl + "order/";
    this.$store.state.dcApiUrl = this.$store.state.apiUrl + "dc/";
    this.$store.state.stripeApiUrl = this.$store.state.apiUrl + "stripe/";
    this.$store.state.gpApiUrl = this.$store.state.apiUrl + "globalpay/";

    let res_initApp = await this.initApp();   
    if (res_initApp) {
      document.title = this.$store.state.companyName;
      let lastLogin = await this.getLastLogin();     
      if (lastLogin != null) {
        if (lastLogin.isMember) {
          let phoneID = "+1" + lastLogin.phone1.replace(/\D+/g, "");
          let isVerifiedPhoneNumber = await this.isVerifiedPhoneNumber(phoneID);        
          if (isVerifiedPhoneNumber) {
            let memberResp = await this.rest_getMember(phoneID);       
            if (memberResp.result == "ok") {             
              this.$store.state.member = memberResp.record.child;
              this.$store.dispatch("getGiftcards");
            }
          }
        }
      }

      this.navHome();
    }

    this.refreshing = false;

    this.$root.addressListDialog = this.$refs.addressListDialog.open;
    this.$root.barcodeDialog = this.$refs.barcodeDialog.open;
    this.$root.confirmDialog = this.$refs.confirmDialog.open;
    this.$root.customFormDialog = this.$refs.customFormDialog.open;
    this.$root.messageDialog = this.$refs.messageDialog.open;
    this.$root.memberGiftcardDialog = this.$refs.memberGiftcardDialog.open;
    this.$root.memberGiftcardTransDialog = this.$refs.memberGiftcardTransDialog.open;
    this.$root.memberLoginDialog = this.$refs.memberLoginDialog.open;
    this.$root.memberPointDialog = this.$refs.memberPointDialog.open;
    this.$root.memberProfileDialog = this.$refs.memberProfileDialog.open;
    this.$root.orderHistoryDialog = this.$refs.orderHistoryDialog.open;
    this.$root.phoneVerificationDialog = this.$refs.phoneVerificationDialog.open;
    this.$root.storeListDialog = this.$refs.storeListDialog.open;
    this.$root.tableNameDialog = this.$refs.tableNameDialog.open;

    this.$root.locationDialog = this.$refs.locationDialog;
  },

  mounted() {},

  computed: {
    routeViewKey() {
      return this.$route.fullPath;
    },
  },

  methods: {
    async offerClicked() {
      this.navOffer();
    },

    openAddressList() {
      this.$store.state.appBar.showDrawer = false;
      this.$root.addressListDialog();
    },

    openOrderHistory() {
      this.$store.state.appBar.showDrawer = false;
      this.$root.orderHistoryDialog();
    },

    navLocationPage() {
      this.$store.state.appBar.showDrawer = false;
      this.$refs.locationDialog.open();
    },

    navPrivacy() {
      this.$store.state.appBar.showDrawer = false;
      this.$refs.privacyDialog.open();
    },

    openHomeWebPage() {
      this.$store.state.appBar.showDrawer = false;
      window.open("https://www.mrsdigi.com");
    },

    onClickMenu() {
      this.showDrawer = true;
    },

    memberBarcode() {
      this.$store.state.appBar.showDrawer = false;
      let barcode = this.$store.state.member.MemberCode;
      this.$root.barcodeDialog(barcode);
    },

    memberLogin() {
      this.$store.state.appBar.showDrawer = false;
      this.$root.memberLoginDialog();
    },

    memberProfile() {
      this.$store.state.appBar.showDrawer = false;
      this.$root.memberProfileDialog(this.$store.state.member);
    },

    memberPoints() {
      this.$store.state.appBar.showDrawer = false;
      this.$root.memberPointDialog();
    },

    memberGiftcard() {
      this.$store.state.appBar.showDrawer = false;

      this.rest_getMember(this.$store.state.member.PhoneId).then(resp => {
        if (resp.result == "ok") {
          this.$store.state.member = resp.record.child;

          this.navName("GiftCard");
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/sass/variables.scss";

$dialog-max-height: 200px;

* {
  touch-action: manipulation;
}

.v-main {
  padding-top: $header-height !important;
}

.v-bottom-navigation {
  height: $bottom-toolbar-height !important;
  .v-btn {
    padding-bottom: env(safe-area-inset-bottom) !important;
  }
}

.desktop-mode-padding {
  padding-left: 300px !important;
  padding-right: 300px !important;
}

.desktop-mode-padding-right {
  padding-right: 300px !important;
}

.desktop-mode-padding-left {
  padding-left: 300px !important;
}

.save-area {
  padding-top: 200px;
}

.fullscreen-dialog {
  height: 100% !important;
  padding-bottom: env(safe-area-inset-bottom) !important;

  //max-width: 600px;
  background-color: white;

  .dialog-card {
    .v-card__title {
      padding: 0px !important;
    }

    .v-card__text {
      height: 100% !important;
    }
  }

  .v-sheet.v-card {
    border-radius: 0px !important;
  }

  .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
  }
}

.no-max-width {
  max-width: 100% !important;
}

.v-navigation-drawer {
  .container {
    margin-top: $header-height;
  }
}

.v-navigation-drawer-cart {
  margin-top: calc(#{$header-height});
  height: calc(100vh - #{$header-height} - #{$bottom-toolbar-height} - 2px) !important;

  .container {
    margin-top: 0px;
  }
}

/* .theme--light.v-navigation-drawer {
    background-color: transparent !important;
} */

.header {
  height: $header-height !important;
  padding-top: env(safe-area-inset-top);
  .row {
    .col {
      padding: 0px;

      .v-btn {
        height: 42px !important;
        color: var(--v-primaryText-base);

        .v-icon {
          color: var(--v-primaryText-base);
        }
      }
    }
  }
}

.header-title1 {
  font-size: 0.75em !important;
  color: var(--v-info-base) !important;
  text-align: center;
}

.header-title2 {
  font-size: 0.9em !important;
  color: var(--v-primaryText-base) !important;
  text-align: center;
}

.header-title2-feature {
  font-size: 0.9em;
  padding: 2px 5px;
  margin: 0px 5px;
  border-radius: 25px;
  background-color: var(--v-info-base);
  color: var(--v-infoText-base);
}

.company-logo {
  //height: 150px;
  //object-fit: contain;

  margin: 48px 0px;

  display: block;
  margin-left: auto;
  margin-right: auto;
}

.store-logo {
  height: 150px;
  object-fit: contain;

  margin: 5px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.store-cover {
  max-height: 300px;
  //height: auto;
  height: 100%;
  width: 100%;
  object-fit: cover;

  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-left: -12px !important;
}

.home-logo {
  @extend .store-logo;

  margin-top: 20px;
  margin-bottom: 20px;

  border-radius: 10px;
}

.horizontal-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.v-switch {
  margin-top: 0px;
  padding-top: 0px;
}

.v-switch-right {
  @extend .v-switch;
  .v-input__control .v-input__slot {
    justify-content: flex-end !important;
  }
}

.menu-card-img {
  object-fit: cover;
  width: 100%;
  border-radius: 5px;
}

.menu-row {
  //margin-right: -12px;
}
.menu-col {
  //border-bottom: dashed 1px rgb(200, 200, 200) !important;
  //border-right: dashed 1px rgb(200, 200, 200) !important;
  //border: dashed 1px rgb(200, 200, 200) !important;
  //margin: 4px;
  padding: 0px;
  min-height: $item-img-height;
}

@media screen and (min-width: 600px) {
  .menu-row {
    padding: 8px;
  }
  .menu-col {
    padding: 8px;
  }
}

.menu-box-no-left-border {
  border-left-style: none !important;
}

.menu-box {
  border: dashed 1px rgb(220, 220, 220); // !important;
  //border-bottom: dashed 1px rgb(220, 220, 220) !important;
  //border-right: dashed 1px rgb(220, 220, 220) !important;
  height: 100%;
  position: relative;

  .ordered-qty {
    position: absolute;
    //display:table-cell;
    line-height: 25px;
    top: 0px;
    width: 25px;
    height: 25px;
    background-color: var(--v-primary-base);
    color: var(--v-primaryText-base);
    text-align: center;
    vertical-align: middle;
    font-size: 0.75em;
    border: solid 1px var(--v-primaryText-base);
  }

  .ordered-qty-right {
    @extend .ordered-qty;
    right: 0;
  }

  .ordered-qty-left {
    @extend .ordered-qty;
    left: 0;
  }

  .menu-img-box {
    height: $item-img-height;
    max-width: $item-img-height;

    img:first-child {
      @extend .menu-card-img;

      height: $item-img-height;
    }

    div:first-child {
      @extend .menu-card-img;

      height: $item-img-height;
    }
  }

  .menu-img-box-xs {
    @extend .menu-img-box;
    max-width: $item-img-xs-height;

    img:first-child {
      @extend .menu-card-img;

      border-radius: $item-img-xs-height;
      padding: 4px;
      //margin-top: -4px;
      height: $item-img-xs-height;
    }

    div:first-child {
      @extend .menu-card-img;

      height: $item-img-xs-height;
    }
  }

  .menu-content-box {
    .item-content {
      font-size: 1em;
      text-align: left;
      min-height: 90px;
      margin-right: 0px;
      margin-left: 0px;
      overflow: hidden;

      .item-barcode {
        font-size: 0.8em;
        font-weight: bold;
        color: var(--v-accent-base);
      }

      .item-detail {
        font-size: 0.8em;
        color: dimgray;

        overflow: hidden;
        white-space: pre-line;
        text-overflow: ellipsis;
        padding-right: 5px;

        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }

    .item-footer {
      .item-points {
        font-weight: bold;
      }

      .item-price {
        font-weight: bold;
      }

      .item-soldout {
        color: var(--v-warning-base);
      }

      .item-disabled {
        color: var(--v-warning-base);
      }
    }

    .item-footer-left {
      @extend .item-footer;
      margin-top: 5px;
      margin-right: 0px;
      margin-left: 0px;
      align-items: center;

      .col {
        padding: 0px;
      }

      .item-attribute {
        .attribute-icon {
          background-color: white;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          text-align: center;
          margin: 0px 0px 5px 0px;
          padding: 2px;
          font-size: 1em;

          &-spicy {
            @extend .attribute-icon;
            color: red;
          }

          &-favorite {
            @extend .attribute-icon;
            color: var(--v-info-base);
          }

          &-veg {
            @extend .attribute-icon;
            color: green;
          }

          &-seafood {
            @extend .attribute-icon;
            color: skyblue;
          }

          &-peanut {
            @extend .attribute-icon;
            color: rgba(peru, 1);
          }

          &-seashell {
            @extend .attribute-icon;
            background-color: seashell;
            margin-bottom: -3px;
            margin-left: 4px;
          }

          &-dairy {
            @extend .attribute-icon;
            background-color: rgba(skyblue, 0.3);
            margin-bottom: -3px;
            margin-left: 4px;
          }
        }
      }

      .item-footer-right {
        @extend .item-footer;
        text-align: right;
      }
    }
  }
}

.order-call-for-request {
  padding: 16px 0px;
  color: var(--v-accent-base);
}
</style>

<style lang="scss" scoped>
.nav-btn-highlight {
  //background-color: var(--v-accentText-base) !important;
}

.v-footer {
  justify-content: center;
  padding: 10px;
}

.side-menu-footer {
  background-color: white !important;
  //background-color: transparent !important;
  margin: 1px !important;
}

.app-powerby {
  flex: 0 1 auto;
  //text-align: left;
  //float: left;
  font-size: 0.7em;
}

.app-version {
  flex: 0 1 auto;
  //text-align: right;
  //float: right;
  font-size: 0.7em;
}

.mrs-m {
  color: rgb(120, 194, 92);
  font-weight: bold;
}

.mrs-r {
  color: rgb(255, 203, 5);
  font-weight: bold;
}

.mrs-s {
  color: rgb(0, 130, 198);
  font-weight: bold;
}

.privacy-policy {
  font-size: 0.75em;
  color: black;
  background-color: lightgrey;
  margin: 15px 0px;
}

.lang-group {
  margin-top: 0px;
  padding-top: 0px;
}

.member-info {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.member-name {
  font-weight: normal;
  color: var(--v-accent-base);
  margin-left: 10px;
  vertical-align: middle;
}

.member-barcode {
  font-size: 2.5em;
  float: right;
  margin-right: 10px;
}

.setting-section {
  margin-bottom: 100px;
}

.address-list-dialog {
  height: 100%;
}
</style>
